import { ISapConfig } from "../types/features/sapConfigSlice";
import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}`; 

export const getSapConfigQuery = async () => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/get-sap-config`, { headers: customHeaders });
  return response.data;
};

export const getSapOrderConfigQuery = async (filter: any) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/sap/get-sales-order-config?filter=${filter}`, { headers: customHeaders });
  return response.data;
};

export const getSapPlantStorageQuery = async (filter: any) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/sap/get-plant-storage-location?filter=${filter}`, { headers: customHeaders });
  return response.data;
};

export const updateSapConfigQuery = async (data: ISapConfig) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.post(`${API_URL}/sap-config`, data, { headers: customHeaders });
  return response.data;
};

export const getSapCompaniesQuery = async () => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/sap/get-sap-companies`, { headers: customHeaders });
  return response.data;
};

export const sendTestEmailQuery = async (email: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.post(`${API_URL}/test-email`, { email }, { headers: customHeaders });
  return response.data;
};


export const testSapConnectionQuery = async (data: {
  sap_base_url: string;
  sap_username: string;
  sap_password: string;
  sap_client: string | number;
}) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`,
  };
  const response = await axiosInstance.post(`${API_URL}/test-sap-connection`, data, { headers: customHeaders });
  return response.data;
};
